import React, { ReactNode } from 'react';
import { useUser } from 'contexts/UserContext';

interface IsMemberProps {
  organizationId: string;
  children: ReactNode;
}

export const IsMember: React.FC<IsMemberProps> = ({ organizationId, children }) => {
  const { user } = useUser();

  if (!user) {
    return null;
  }

  const isMember = user.organizationPermissions.some(member => member.organizationId === organizationId);

  return isMember ? <>{children}</> : null;
};

export default IsMember;